const getPosition = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return reject(new Error("Perangkat tidak mendukung lokasi"));
  navigator.geolocation.getCurrentPosition(resolve, () => reject(new Error("Izinkan akses lokasi untuk memotret rumah/tempat usaha")),
    { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 });
});

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => reject(new Error("Foto tidak dapat dibaca, ambil ulang"));
  img.src = url;
});

export const fmtCoord = (g) => `${g.lat.toFixed(6)}, ${g.lng.toFixed(6)}`;
export const mapsUrl = (g) => `https://www.google.com/maps/search/?api=1&query=${g.lat},${g.lng}`;

export async function stampGeoPhoto(file) {
  const pos = await getPosition();
  const geo = { lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy, taken_at: new Date().toISOString() };
  const img = await loadImage(file);
  const scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
  const w = Math.round(img.naturalWidth * scale), h = Math.round(img.naturalHeight * scale);
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const ctx = c.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  const fs = Math.max(14, Math.round(w / 38));
  const lines = [
    `Lat/Long: ${fmtCoord(geo)} (±${Math.round(geo.accuracy)} m)`,
    new Date(geo.taken_at).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "short" }),
    "CU Tuah Talino • Foto Rumah/Tempat Usaha",
  ];
  const band = fs * 1.45 * lines.length + fs;
  ctx.fillStyle = "rgba(11,20,55,0.62)";
  ctx.fillRect(0, h - band, w, band);
  ctx.fillStyle = "#fff";
  ctx.textBaseline = "top";
  lines.forEach((l, i) => {
    ctx.font = `${i === 0 ? "bold " : ""}${fs}px sans-serif`;
    ctx.fillText(l, fs * 0.7, h - band + fs * 0.5 + i * fs * 1.45);
  });
  const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.88));
  return { blob, geo };
}
